import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ByteChannel3cxdguezl3lu7 as ByteChannel } from './ByteChannel.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function attachJob(_this__u8e3s4, job) {
  job.by(true, VOID, (it) => {
    var tmp;
    if (!(it == null)) {
      _this__u8e3s4.o4n(it);
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
}
function attachWriterJob(_this__u8e3s4, writerJob) {
  var tmp = writerJob.a4o_1;
  var tmp0_safe_receiver = tmp instanceof ByteChannel() ? tmp : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.p4n((cause) => {
      var tmp;
      if (!(cause == null)) {
        _this__u8e3s4.o4n(cause);
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
  }
}
//region block: exports
export {
  attachJob as attachJoby0kwkw2fc958,
  attachWriterJob as attachWriterJob2dr3tee7atoa9,
};
//endregion

//# sourceMappingURL=ByteChannelUtils.mjs.map
